import { ITEMS_PER_PAGE_OPTIONS, MAX_VISIBLE_PAGES } from "../../constants/app";
import { IPageLink } from "../../models/superadmin";
import Pagination from "./Pagination";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  paginationLinks: IPageLink[];
  itemsPerPageOptions?: number[]; // optional override
  onPageChange: (event: any) => void;
  setPerPageList: (value: number) => void;
  setCurrentPage: (value: number) => void;
}

export default function PaginationControls({
  currentPage,
  totalPages,
  paginationLinks,
  itemsPerPageOptions,
  onPageChange,
  setPerPageList,
  setCurrentPage,
}: PaginationProps) {
  const options = itemsPerPageOptions ?? ITEMS_PER_PAGE_OPTIONS;

  return (
    <div className="pt-10px">
      <div className="d-flex gap-5 align-items-center justify-content-end flex-wrap">
        <div className="d-flex gap-3 align-items-center">
          <div className="fs-13 text-black text-nowrap">Items per page</div>
          <div className="form-group">
            <select
              id="itemsPerPage"
              className="form-select text-only"
              title="Items per page"
              onChange={(e) => {
                setPerPageList(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              {options.map((item, index) => (
                <option key={index} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          paginationLinks={paginationLinks}
          maxVisiblePages={MAX_VISIBLE_PAGES}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
}
